import {FC} from 'external/react';

const labelStyle: React.CSSProperties = {
  display: 'block', marginBottom: 6,
  fontSize: 11, fontWeight: 700, color: '#475569',
  textTransform: 'uppercase', letterSpacing: '0.06em',
};

const selectStyle: React.CSSProperties = {
  width: '100%', padding: '9px 36px 9px 12px',
  fontSize: 14, color: '#1e293b',
  background: '#fff', border: '1.5px solid #e2e8f0',
  borderRadius: 8, outline: 'none',
  appearance: 'none',
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  transition: 'border-color 150ms',
};

type StyledSelectProps = {
  label: string;
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  placeholder: string;
  emptyMessage?: string;
  children?: React.ReactNode;
};

const StyledSelect: FC<StyledSelectProps> = ({
  value, onChange, disabled, placeholder, emptyMessage, label, children,
}) => (
  <div>
    {label && (<label style={labelStyle}>{label}</label>)}
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      style={{
        ...selectStyle,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <option value=''>{emptyMessage ?? placeholder}</option>
      {children}
    </select>
  </div>
);

export default StyledSelect;